import script from "./HomeGarantia.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeGarantia.vue?vue&type=script&setup=true&lang=js"

import "./HomeGarantia.vue?vue&type=style&index=0&id=2339fb2d&lang=css"

const __exports__ = script;

export default __exports__